import { trackLink, trackImpression } from 'lib/analytics/fpti'

/**
 * Track block user click from contact details page
 **/
export function trackBlockContactClick() {
  trackLink('block', 'link')
}

/**
 * Track block user confirmation overpanel impression
 **/
export function trackBlockContactImpression() {
  trackImpression()
}

/**
 * Track block user confirm button from block confirmation
 **/
export function trackBlockConfirmationClick() {
  trackLink('block', 'link')
}

/**
 * Track block user cancel from block confirmation
 **/
export function trackBlockCancelClick() {
  trackLink('cancel', 'link')
}

/**
 * Track blocked contact success overpanel impression
 **/
export function trackBlockContactSuccessImpression() {
  trackImpression({
    message_shown: 'contact_blocked',
  })
}

/**
 * Track blocked contacts link clicks from contact list
 **/
export function trackViewBlockedContactsLink() {
  trackLink('blocked_users', 'link')
}

/**
 * Track block user error overpanel
 **/
export function trackBlockedContactsImpression() {
  trackImpression()
}

/**
 * Track unblock contact link
 **/
export function trackUnblockContactLink({ payerId }) {
  trackLink('undo', 'link', { encr_rcvr_id: payerId })
}

/**
 * Track unblocked contact success overpanel impression
 **/
export function trackUnblockContactSuccessImpression() {
  trackImpression({
    message_shown: 'contact_unblocked',
  })
}

/**
 * Track error message sending/requesting to/from a blocked contact
 **/
export function trackContactBlockedErrorImpression() {
  trackImpression()
}
